import React from 'react';
import { Button } from 'reactstrap';
import { Trans, useTranslation } from 'react-i18next';

const LocalADGeneral = () => {
    const { t } = useTranslation(['help']);

    return (
        <div>
            <h1>{t('localAdGeneral.title', { ns: 'help' })}</h1>
            <h3>{t('localAdGeneral.description.title', { ns: 'help' })}</h3>
            <p>{t('localAdGeneral.description.text1', { ns: 'help' })}</p>
            <ul>
                <li>{t('localAdGeneral.description.matchTypes.system', { ns: 'help' })}</li>
                <li>{t('localAdGeneral.description.matchTypes.ssnHash', { ns: 'help' })}</li>
                <li>{t('localAdGeneral.description.matchTypes.socialnumber', { ns: 'help' })}</li>
            </ul>
            <p>{t('localAdGeneral.description.text2', { ns: 'help' })}</p>
            <h3>{t('localAdGeneral.mappingFields.title', { ns: 'help' })}</h3>
            <ul>
                <li>{t('localAdGeneral.mappingFields.externalId', { ns: 'help' })}</li>
                <li>{t('localAdGeneral.mappingFields.systemName', { ns: 'help' })}</li>
                <li>{t('localAdGeneral.mappingFields.ssnHash', { ns: 'help' })}
                    <ul>
                        <li>{t('localAdGeneral.ssnParts.yyyy', { ns: 'help' })}</li>
                        <li>{t('localAdGeneral.ssnParts.mm', { ns: 'help' })}</li>
                        <li>{t('localAdGeneral.ssnParts.dd', { ns: 'help' })}</li>
                        <li>{t('localAdGeneral.ssnParts.xxxz', { ns: 'help' })}</li>
                    </ul>
                </li>
                <li>{t('localAdGeneral.mappingFields.socialnumber', { ns: 'help' })}
                    <ul>
                        <li>{t('localAdGeneral.ssnParts.yyyy', { ns: 'help' })}</li>
                        <li>{t('localAdGeneral.ssnParts.mm', { ns: 'help' })}</li>
                        <li>{t('localAdGeneral.ssnParts.dd', { ns: 'help' })}</li>
                        <li>{t('localAdGeneral.ssnParts.xxxz', { ns: 'help' })}</li>
                    </ul>
                </li>
            </ul>
            <h3>{t('localAdGeneral.dataFields.title', { ns: 'help' })}</h3>
            <ul>
                <li>{t('localAdGeneral.dataFields.workEmail', { ns: 'help' })}</li>
                <li>{t('localAdGeneral.dataFields.personalEmail', { ns: 'help' })}</li>
                <li>{t('localAdGeneral.dataFields.eduStudentEmail', { ns: 'help' })}</li>
                <li>{t('localAdGeneral.dataFields.eduStaffEmail', { ns: 'help' })}</li>
                <li>{t('localAdGeneral.dataFields.workOtherEmail', { ns: 'help' })}</li>
                <li>{t('localAdGeneral.dataFields.eduStudentEppn', { ns: 'help' })}</li>
                <li>{t('localAdGeneral.dataFields.eduStaffEppn', { ns: 'help' })}</li>
            </ul>
            <hr />
            <p>{t('localAdGeneral.delimiterNotice', { ns: 'help' })}</p>
            <a href="/help-images/Local AD Example.csv" download><Button className="btn-primary">{t('localAdGeneral.downloadExample', { ns: 'help' })}</Button></a>
        </div>
    )
}

export default LocalADGeneral;
